// 2023/4/17 common.js

export default {
  uploadFileUrl: 'https://static.congraedu.cn/api/v2/file/uploadLocalFile',
  headers: {
    Authorization: "Bearer " + localStorage.getItem("token")
  }
}



// WEBPACK FOOTER //
// ./src/config/common.js